// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user-center-page {
    background-color: transparent;
    min-height: 100vh;
    padding: 2.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
}

.user-center-header-icons {
    position: absolute;
    top: 1.5rem;
    right: 2rem;
    z-index: 10;
}

.user-center-icon-btn {
    width: 50px;
    height: 50px;
    border-radius: 1000px;
    border: none;
    background-color: rgba(0, 0, 0, 0.45);
    backdrop-filter: blur(20px);
    -webkit-backdrop-filter: blur(20px);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.3s ease;
    position: relative;
    isolation: isolate;
    color: rgba(213, 190, 155, 1);
}

.user-center-icon-btn::before {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: 1000px;
    padding: 1px;
    background: radial-gradient(203.89% 137.16% at 36.99% -13.51%, #FFDC6C 0%, #FFFFFF 0%, #B19742 76.21%, #A8924B 82.96%);
    -webkit-mask:
        linear-gradient(#fff 0 0) content-box,
        linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask:
        linear-gradient(#fff 0 0) content-box,
        linear-gradient(#fff 0 0);
    mask-composite: exclude;
    pointer-events: none;
}

.user-center-icon-btn img {
    width: 22px;
    height: 22px;
    object-fit: contain;
}

.user-center-icon-btn:hover {
    transform: scale(1.05);
    background-color: rgba(0, 0, 0, 0.6);
}

.user-center-content {
    width: 100%;
    max-width: 1400px;
    display: flex;
    flex-direction: column;
    gap: 2rem;
}

.user-center-main-row {
    display: flex;
    gap: 1.5rem;
    align-items: stretch;
    width: 100%;
}

.user-center-hero {
    background-color: rgba(0, 0, 0, 0.45);
    backdrop-filter: blur(20px);
    -webkit-backdrop-filter: blur(20px);
    border-radius: 32px;
    padding: 3rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    position: relative;
    flex: 1 1;
    min-width: 0;
}

.user-center-hero::before {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: 32px;
    padding: 1px;
    background: radial-gradient(203.89% 137.16% at 36.99% -13.51%, #FFDC6C 0%, #FFFFFF 0%, #B19742 76.21%, #A8924B 82.96%);
    -webkit-mask:
        linear-gradient(#fff 0 0) content-box,
        linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask:
        linear-gradient(#fff 0 0) content-box,
        linear-gradient(#fff 0 0);
    mask-composite: exclude;
    pointer-events: none;
}

.hero-left {
    display: flex;
    align-items: center;
    gap: 1.5rem;
}

.hero-avatar {
    width: 110px;
    height: 110px;
    border-radius: 50%;
    border: 2px solid rgba(213, 190, 155, 0.6);
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: 'CormorantSC-Regular', 'Times New Roman', serif;
    font-size: 2.2rem;
    color: rgba(213, 190, 155, 1);
}

.hero-info {
    display: flex;
    flex-direction: column;
    gap: 0.35rem;
    flex: 1 1;
}

.hero-meta-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
    gap: 0.75rem;
    margin-top: 1.25rem;
}

.hero-meta-card {
    padding: 0.85rem 1rem;
    border-radius: 16px;
    background-color: rgba(0, 0, 0, 0.35);
    border: 1px solid rgba(213, 190, 155, 0.2);
    display: flex;
    flex-direction: column;
    gap: 0.4rem;
}

.hero-meta-label {
    font-size: 0.7rem;
    letter-spacing: 0.18em;
    color: rgba(213, 190, 155, 0.7);
}

.hero-meta-value {
    font-size: 1rem;
    color: rgba(213, 190, 155, 0.95);
    letter-spacing: 0.05em;
}

.hero-divider {
    width: 100%;
    height: 1px;
    background: linear-gradient(90deg, transparent, rgba(213, 190, 155, 0.5), transparent);
    margin: 0.5rem 0;
    position: relative;
}

.hero-divider::after {
    content: '★';
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    color: rgba(213, 190, 155, 0.8);
    font-size: 0.6rem;
    background-color: rgba(0, 0, 0, 0.8);
    padding: 0 0.3rem;
}

.hero-name {
    font-family: 'CormorantSC-Regular', 'Times New Roman', serif;
    font-size: 2.2rem;
    color: #D5BE9B;
    margin: 0;
    letter-spacing: 0.15em;
    /* Override global h1 gradient effect */
    background: none;
    background-clip: unset;
    -webkit-text-fill-color: #D5BE9B;
    display: flex;
    align-items: center;
    gap: 0.8rem;
    flex-wrap: wrap;
}

.founder-badge {
    display: inline-flex;
    align-items: center;
    gap: 0.3rem;
    padding: 0.3rem 1rem;
    font-size: 0.75rem;
    font-weight: 600;
    letter-spacing: 0.15em;
    color: #D5BE9B;
    background: rgba(213, 190, 155, 0.15);
    border: 1px solid rgba(213, 190, 155, 0.5);
    border-radius: 20px;
    text-shadow: 0 0 10px rgba(195, 136, 48, 0.5);
    box-shadow: 0 0 15px rgba(195, 136, 48, 0.2);
    animation: founderGlow 2s ease-in-out infinite alternate;
    -webkit-text-fill-color: #D5BE9B;
}

@keyframes founderGlow {
    from {
        box-shadow: 0 0 10px rgba(195, 136, 48, 0.2);
        border-color: rgba(195, 136, 48, 0.4);
    }

    to {
        box-shadow: 0 0 20px rgba(195, 136, 48, 0.4);
        border-color: rgba(195, 136, 48, 0.7);
    }
}

.hero-email {
    font-size: 1.1rem;
    letter-spacing: 0.1em;
    color: rgba(213, 190, 155, 0.8);
    margin: 0;
}

.hero-balance-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 0.85rem;
    letter-spacing: 0.1em;
    color: rgba(213, 190, 155, 0.9);
}

.balance-value {
    font-size: 1rem;
    color: rgba(213, 190, 155, 1);
}

.balance-progress {
    width: 100%;
    max-width: 400px;
    height: 8px;
    border-radius: 1000px;
    background-color: rgba(213, 190, 155, 0.2);
    overflow: hidden;
    margin-top: 0.4rem;
}

.progress-fill {
    height: 100%;
    background: linear-gradient(90deg, rgba(213, 190, 155, 0.7), rgba(255, 255, 255, 0.9));
    border-radius: inherit;
}

.hero-redeem {
    display: flex;
    gap: 1.25rem;
    align-items: center;
    margin-top: 1.5rem;
    width: 100%;
    flex-wrap: nowrap;
}

.redeem-input {
    flex: 1 1;
    min-width: 0;
    max-width: 520px;
    padding: 1.1rem 2.25rem;
    border-radius: 1000px;
    border: 1px solid rgba(249, 230, 173, 0.4);
    background: linear-gradient(135deg, rgba(6, 6, 6, 0.85) 0%, rgba(12, 12, 12, 0.92) 100%);
    box-shadow:
        inset 0 0 25px rgba(0, 0, 0, 0.6),
        0 10px 25px rgba(0, 0, 0, 0.45);
    color: rgba(249, 230, 173, 0.95);
    font-family: 'CormorantSC-Regular', 'Times New Roman', serif;
    font-style: italic;
    letter-spacing: 0.08em;
    font-size: 1.05rem;
    transition: border-color 0.3s ease, box-shadow 0.3s ease, color 0.3s ease;
}

.redeem-input::placeholder {
    color: rgba(249, 230, 173, 0.7);
}

.redeem-input:focus {
    outline: none;
    border-color: rgba(255, 220, 150, 0.9);
    box-shadow:
        inset 0 0 25px rgba(0, 0, 0, 0.55),
        0 15px 35px rgba(0, 0, 0, 0.6),
        0 0 12px rgba(255, 223, 158, 0.35);
    color: rgba(255, 244, 214, 0.95);
}

.redeem-input-error {
    border: 1px solid rgba(255, 138, 138, 0.8);
    color: rgba(255, 200, 200, 0.95);
    background: linear-gradient(135deg, rgba(24, 5, 5, 0.9) 0%, rgba(42, 6, 6, 0.9) 100%);
    box-shadow:
        inset 0 0 25px rgba(0, 0, 0, 0.6),
        0 10px 25px rgba(122, 20, 20, 0.25);
}

.redeem-input-error::placeholder {
    color: rgba(255, 190, 190, 0.8);
}

.redeem-btn {
    flex: 0 0 auto;
    white-space: nowrap;
    padding: 1rem 2.8rem;
    border-radius: 1000px;
    border: 1px solid rgba(249, 230, 173, 0.5);
    background: linear-gradient(135deg, rgba(7, 7, 7, 0.92) 0%, rgba(25, 25, 25, 0.9) 100%);
    color: rgba(249, 230, 173, 0.9);
    font-family: 'CormorantSC-Regular', 'Times New Roman', serif;
    letter-spacing: 0.15em;
    cursor: pointer;
    transition: all 0.3s ease;
    font-size: 1rem;
    text-transform: uppercase;
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.45);
}

.redeem-btn:hover {
    background: linear-gradient(135deg, rgba(40, 40, 40, 0.95) 0%, rgba(20, 20, 20, 0.9) 100%);
    transform: translateY(-2px);
    border-color: rgba(255, 220, 150, 0.9);
    color: rgba(255, 244, 214, 0.95);
}

.redeem-btn:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
    box-shadow: none;
}


.widget-card {
    background-color: rgba(0, 0, 0, 0.45);
    backdrop-filter: blur(20px);
    -webkit-backdrop-filter: blur(20px);
    border-radius: 24px;
    padding: 2rem;
    border: none;
    text-align: center;
    cursor: pointer;
    color: rgba(213, 190, 155, 1);
    position: relative;
    isolation: isolate;
    transition: all 0.3s ease;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-width: 200px;
    flex: 0 0 auto;
}

.widget-card::before {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: 24px;
    padding: 1px;
    background: radial-gradient(203.89% 137.16% at 36.99% -13.51%, #FFDC6C 0%, #FFFFFF 0%, #B19742 76.21%, #A8924B 82.96%);
    -webkit-mask:
        linear-gradient(#fff 0 0) content-box,
        linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask:
        linear-gradient(#fff 0 0) content-box,
        linear-gradient(#fff 0 0);
    mask-composite: exclude;
    pointer-events: none;
}

.widget-card:hover {
    transform: translateY(-4px);
}

.widget-icon {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    border: 2px solid rgba(213, 190, 155, 0.6);
    background-color: rgba(0, 0, 0, 0.7);
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 1rem;
}

.widget-icon img {
    width: 40px;
    height: 40px;
    object-fit: contain;
}

.widget-title {
    font-family: 'CormorantSC-Regular', 'Times New Roman', serif;
    font-size: 1.1rem;
    letter-spacing: 0.1em;
    margin: 0;
}

.user-center-actions {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    flex: 0 0 auto;
    min-width: 180px;
}

.action-button {
    background-color: rgba(0, 0, 0, 0.45);
    backdrop-filter: blur(20px);
    -webkit-backdrop-filter: blur(20px);
    border-radius: 24px;
    border: none;
    cursor: pointer;
    padding: 1rem 1.5rem;
    transition: all 0.3s ease;
    position: relative;
    isolation: isolate;
    text-align: center;
    width: 100%;
}

.action-button::before {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: 24px;
    padding: 1px;
    background: radial-gradient(203.89% 137.16% at 36.99% -13.51%, #FFDC6C 0%, #FFFFFF 0%, #B19742 76.21%, #A8924B 82.96%);
    -webkit-mask:
        linear-gradient(#fff 0 0) content-box,
        linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask:
        linear-gradient(#fff 0 0) content-box,
        linear-gradient(#fff 0 0);
    mask-composite: exclude;
    pointer-events: none;
}

.action-button-label {
    font-family: 'CormorantSC-Regular', 'Times New Roman', serif;
    font-size: 0.95rem;
    letter-spacing: 0.15em;
    color: rgba(213, 190, 155, 1);
    white-space: nowrap;
}

.action-button:hover {
    transform: translateY(-2px);
    background-color: rgba(0, 0, 0, 0.6);
}

@media (max-width: 900px) {
    .user-center-main-row {
        flex-direction: column;
    }

    .user-center-hero {
        flex-direction: column;
        gap: 1.5rem;
    }

    .hero-redeem {
        width: 100%;
        flex-direction: column;
        align-items: stretch;
    }

    .redeem-input {
        width: 100%;
        min-width: unset;
    }

    .redeem-btn {
        width: 100%;
    }

    .widget-card {
        min-width: unset;
    }

    .user-center-actions {
        flex-direction: row;
        min-width: unset;
    }
}

@media (max-width: 540px) {
    .user-center-page {
        padding: 1rem;
        padding-top: 5rem;
        /* More space for header icons */
        align-items: flex-start;
        /* Prevent clipping */
    }

    .user-center-header-icons {
        top: 1rem;
        right: 1rem;
    }

    .user-center-hero {
        padding: 1.5rem;
        gap: 1.5rem;
    }

    .hero-left {
        flex-direction: column;
        align-items: center;
        width: 100%;
    }

    .hero-avatar {
        width: 90px;
        height: 90px;
        font-size: 1.5rem;
        margin-bottom: 0.5rem;
    }

    .hero-info {
        width: 100%;
        align-items: center;
        text-align: center;
    }

    .hero-name {
        font-size: 1.8rem;
    }

    .hero-email {
        font-size: 0.95rem;
    }

    .hero-divider {
        width: 80%;
        /* Don't span full width if centered */
    }

    .hero-balance-row {
        width: 100%;
        max-width: 280px;
        justify-content: space-between;
    }

    .balance-progress {
        width: 100%;
        max-width: 280px;
    }

    .hero-redeem {
        margin-top: 1rem;
        gap: 0.75rem;
    }

    .redeem-input {
        padding: 0.9rem 1.5rem;
        font-size: 0.95rem;
    }

    .redeem-btn {
        padding: 0.9rem;
        width: 100%;
    }

    /* Transform Widgets to Horizontal List Items for better space usage */
    .widget-card {
        flex-direction: row;
        padding: 1rem 1.5rem;
        gap: 1rem;
        align-items: center;
        justify-content: flex-start;
        min-height: 80px;
    }

    .widget-icon {
        width: 48px;
        height: 48px;
        margin-bottom: 0;
        /* Override the default margin */
        flex-shrink: 0;
    }

    .widget-icon img {
        width: 24px;
        height: 24px;
    }

    .widget-title {
        font-size: 1rem;
        text-align: left;
    }

    .user-center-actions {
        margin-top: 0.5rem;
    }
}`, "",{"version":3,"sources":["webpack://./src/userCenter/userCenter.css"],"names":[],"mappings":"AAAA;IACI,6BAA6B;IAC7B,iBAAiB;IACjB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,qBAAqB;IACrB,YAAY;IACZ,qCAAqC;IACrC,2BAA2B;IAC3B,mCAAmC;IACnC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,6BAA6B;AACjC;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,qBAAqB;IACrB,YAAY;IACZ,sHAAsH;IACtH;;iCAE6B;IAC7B,2BAA2B;IAC3B;;iCAE6B;IAC7B,uBAAuB;IACvB,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,oCAAoC;AACxC;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,WAAW;IACX,oBAAoB;IACpB,WAAW;AACf;;AAEA;IACI,qCAAqC;IACrC,2BAA2B;IAC3B,mCAAmC;IACnC,mBAAmB;IACnB,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,kBAAkB;IAClB,SAAO;IACP,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,mBAAmB;IACnB,YAAY;IACZ,sHAAsH;IACtH;;iCAE6B;IAC7B,2BAA2B;IAC3B;;iCAE6B;IAC7B,uBAAuB;IACvB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,0CAA0C;IAC1C,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,4DAA4D;IAC5D,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,SAAO;AACX;;AAEA;IACI,aAAa;IACb,2DAA2D;IAC3D,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,qCAAqC;IACrC,0CAA0C;IAC1C,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,sBAAsB;IACtB,+BAA+B;AACnC;;AAEA;IACI,eAAe;IACf,gCAAgC;IAChC,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,WAAW;IACX,sFAAsF;IACtF,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,gCAAgC;IAChC,+BAA+B;IAC/B,iBAAiB;IACjB,oCAAoC;IACpC,iBAAiB;AACrB;;AAEA;IACI,4DAA4D;IAC5D,iBAAiB;IACjB,cAAc;IACd,SAAS;IACT,sBAAsB;IACtB,uCAAuC;IACvC,gBAAgB;IAEhB,sBAAsB;IACtB,gCAAgC;IAChC,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,WAAW;IACX,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,cAAc;IACd,qCAAqC;IACrC,0CAA0C;IAC1C,mBAAmB;IACnB,6CAA6C;IAC7C,4CAA4C;IAC5C,wDAAwD;IACxD,gCAAgC;AACpC;;AAEA;IACI;QACI,4CAA4C;QAC5C,qCAAqC;IACzC;;IAEA;QACI,4CAA4C;QAC5C,qCAAqC;IACzC;AACJ;;AAEA;IACI,iBAAiB;IACjB,qBAAqB;IACrB,+BAA+B;IAC/B,SAAS;AACb;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,qBAAqB;IACrB,+BAA+B;AACnC;;AAEA;IACI,eAAe;IACf,6BAA6B;AACjC;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,WAAW;IACX,qBAAqB;IACrB,0CAA0C;IAC1C,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,sFAAsF;IACtF,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,SAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;IACvB,qBAAqB;IACrB,0CAA0C;IAC1C,wFAAwF;IACxF;;uCAEmC;IACnC,gCAAgC;IAChC,4DAA4D;IAC5D,kBAAkB;IAClB,sBAAsB;IACtB,kBAAkB;IAClB,yEAAyE;AAC7E;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,sCAAsC;IACtC;;;0CAGsC;IACtC,gCAAgC;AACpC;;AAEA;IACI,0CAA0C;IAC1C,gCAAgC;IAChC,qFAAqF;IACrF;;2CAEuC;AAC3C;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,oBAAoB;IACpB,qBAAqB;IACrB,0CAA0C;IAC1C,uFAAuF;IACvF,+BAA+B;IAC/B,4DAA4D;IAC5D,sBAAsB;IACtB,eAAe;IACf,yBAAyB;IACzB,eAAe;IACf,yBAAyB;IACzB,2CAA2C;AAC/C;;AAEA;IACI,0FAA0F;IAC1F,2BAA2B;IAC3B,sCAAsC;IACtC,gCAAgC;AACpC;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;;AAGA;IACI,qCAAqC;IACrC,2BAA2B;IAC3B,mCAAmC;IACnC,mBAAmB;IACnB,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,6BAA6B;IAC7B,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;IACzB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,mBAAmB;IACnB,YAAY;IACZ,sHAAsH;IACtH;;iCAE6B;IAC7B,2BAA2B;IAC3B;;iCAE6B;IAC7B,uBAAuB;IACvB,oBAAoB;AACxB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,0CAA0C;IAC1C,oCAAoC;IACpC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,4DAA4D;IAC5D,iBAAiB;IACjB,qBAAqB;IACrB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,qCAAqC;IACrC,2BAA2B;IAC3B,mCAAmC;IACnC,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,oBAAoB;IACpB,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,mBAAmB;IACnB,YAAY;IACZ,sHAAsH;IACtH;;iCAE6B;IAC7B,2BAA2B;IAC3B;;iCAE6B;IAC7B,uBAAuB;IACvB,oBAAoB;AACxB;;AAEA;IACI,4DAA4D;IAC5D,kBAAkB;IAClB,sBAAsB;IACtB,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;IAC3B,oCAAoC;AACxC;;AAEA;IACI;QACI,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;QACtB,WAAW;IACf;;IAEA;QACI,WAAW;QACX,sBAAsB;QACtB,oBAAoB;IACxB;;IAEA;QACI,WAAW;QACX,gBAAgB;IACpB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;QACnB,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,aAAa;QACb,iBAAiB;QACjB,gCAAgC;QAChC,uBAAuB;QACvB,qBAAqB;IACzB;;IAEA;QACI,SAAS;QACT,WAAW;IACf;;IAEA;QACI,eAAe;QACf,WAAW;IACf;;IAEA;QACI,sBAAsB;QACtB,mBAAmB;QACnB,WAAW;IACf;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,iBAAiB;QACjB,qBAAqB;IACzB;;IAEA;QACI,WAAW;QACX,mBAAmB;QACnB,kBAAkB;IACtB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,UAAU;QACV,sCAAsC;IAC1C;;IAEA;QACI,WAAW;QACX,gBAAgB;QAChB,8BAA8B;IAClC;;IAEA;QACI,WAAW;QACX,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;QAChB,YAAY;IAChB;;IAEA;QACI,sBAAsB;QACtB,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,WAAW;IACf;;IAEA,sEAAsE;IACtE;QACI,mBAAmB;QACnB,oBAAoB;QACpB,SAAS;QACT,mBAAmB;QACnB,2BAA2B;QAC3B,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,gBAAgB;QAChB,gCAAgC;QAChC,cAAc;IAClB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;IACtB;AACJ","sourcesContent":[".user-center-page {\r\n    background-color: transparent;\r\n    min-height: 100vh;\r\n    padding: 2.5rem;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    position: relative;\r\n}\r\n\r\n.user-center-header-icons {\r\n    position: absolute;\r\n    top: 1.5rem;\r\n    right: 2rem;\r\n    z-index: 10;\r\n}\r\n\r\n.user-center-icon-btn {\r\n    width: 50px;\r\n    height: 50px;\r\n    border-radius: 1000px;\r\n    border: none;\r\n    background-color: rgba(0, 0, 0, 0.45);\r\n    backdrop-filter: blur(20px);\r\n    -webkit-backdrop-filter: blur(20px);\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    cursor: pointer;\r\n    transition: all 0.3s ease;\r\n    position: relative;\r\n    isolation: isolate;\r\n    color: rgba(213, 190, 155, 1);\r\n}\r\n\r\n.user-center-icon-btn::before {\r\n    content: '';\r\n    position: absolute;\r\n    inset: 0;\r\n    border-radius: 1000px;\r\n    padding: 1px;\r\n    background: radial-gradient(203.89% 137.16% at 36.99% -13.51%, #FFDC6C 0%, #FFFFFF 0%, #B19742 76.21%, #A8924B 82.96%);\r\n    -webkit-mask:\r\n        linear-gradient(#fff 0 0) content-box,\r\n        linear-gradient(#fff 0 0);\r\n    -webkit-mask-composite: xor;\r\n    mask:\r\n        linear-gradient(#fff 0 0) content-box,\r\n        linear-gradient(#fff 0 0);\r\n    mask-composite: exclude;\r\n    pointer-events: none;\r\n}\r\n\r\n.user-center-icon-btn img {\r\n    width: 22px;\r\n    height: 22px;\r\n    object-fit: contain;\r\n}\r\n\r\n.user-center-icon-btn:hover {\r\n    transform: scale(1.05);\r\n    background-color: rgba(0, 0, 0, 0.6);\r\n}\r\n\r\n.user-center-content {\r\n    width: 100%;\r\n    max-width: 1400px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 2rem;\r\n}\r\n\r\n.user-center-main-row {\r\n    display: flex;\r\n    gap: 1.5rem;\r\n    align-items: stretch;\r\n    width: 100%;\r\n}\r\n\r\n.user-center-hero {\r\n    background-color: rgba(0, 0, 0, 0.45);\r\n    backdrop-filter: blur(20px);\r\n    -webkit-backdrop-filter: blur(20px);\r\n    border-radius: 32px;\r\n    padding: 3rem;\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: space-between;\r\n    position: relative;\r\n    flex: 1;\r\n    min-width: 0;\r\n}\r\n\r\n.user-center-hero::before {\r\n    content: '';\r\n    position: absolute;\r\n    inset: 0;\r\n    border-radius: 32px;\r\n    padding: 1px;\r\n    background: radial-gradient(203.89% 137.16% at 36.99% -13.51%, #FFDC6C 0%, #FFFFFF 0%, #B19742 76.21%, #A8924B 82.96%);\r\n    -webkit-mask:\r\n        linear-gradient(#fff 0 0) content-box,\r\n        linear-gradient(#fff 0 0);\r\n    -webkit-mask-composite: xor;\r\n    mask:\r\n        linear-gradient(#fff 0 0) content-box,\r\n        linear-gradient(#fff 0 0);\r\n    mask-composite: exclude;\r\n    pointer-events: none;\r\n}\r\n\r\n.hero-left {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 1.5rem;\r\n}\r\n\r\n.hero-avatar {\r\n    width: 110px;\r\n    height: 110px;\r\n    border-radius: 50%;\r\n    border: 2px solid rgba(213, 190, 155, 0.6);\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    font-family: 'CormorantSC-Regular', 'Times New Roman', serif;\r\n    font-size: 2.2rem;\r\n    color: rgba(213, 190, 155, 1);\r\n}\r\n\r\n.hero-info {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 0.35rem;\r\n    flex: 1;\r\n}\r\n\r\n.hero-meta-grid {\r\n    display: grid;\r\n    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\r\n    gap: 0.75rem;\r\n    margin-top: 1.25rem;\r\n}\r\n\r\n.hero-meta-card {\r\n    padding: 0.85rem 1rem;\r\n    border-radius: 16px;\r\n    background-color: rgba(0, 0, 0, 0.35);\r\n    border: 1px solid rgba(213, 190, 155, 0.2);\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 0.4rem;\r\n}\r\n\r\n.hero-meta-label {\r\n    font-size: 0.7rem;\r\n    letter-spacing: 0.18em;\r\n    color: rgba(213, 190, 155, 0.7);\r\n}\r\n\r\n.hero-meta-value {\r\n    font-size: 1rem;\r\n    color: rgba(213, 190, 155, 0.95);\r\n    letter-spacing: 0.05em;\r\n}\r\n\r\n.hero-divider {\r\n    width: 100%;\r\n    height: 1px;\r\n    background: linear-gradient(90deg, transparent, rgba(213, 190, 155, 0.5), transparent);\r\n    margin: 0.5rem 0;\r\n    position: relative;\r\n}\r\n\r\n.hero-divider::after {\r\n    content: '★';\r\n    position: absolute;\r\n    left: 50%;\r\n    top: 50%;\r\n    transform: translate(-50%, -50%);\r\n    color: rgba(213, 190, 155, 0.8);\r\n    font-size: 0.6rem;\r\n    background-color: rgba(0, 0, 0, 0.8);\r\n    padding: 0 0.3rem;\r\n}\r\n\r\n.hero-name {\r\n    font-family: 'CormorantSC-Regular', 'Times New Roman', serif;\r\n    font-size: 2.2rem;\r\n    color: #D5BE9B;\r\n    margin: 0;\r\n    letter-spacing: 0.15em;\r\n    /* Override global h1 gradient effect */\r\n    background: none;\r\n    -webkit-background-clip: unset;\r\n    background-clip: unset;\r\n    -webkit-text-fill-color: #D5BE9B;\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 0.8rem;\r\n    flex-wrap: wrap;\r\n}\r\n\r\n.founder-badge {\r\n    display: inline-flex;\r\n    align-items: center;\r\n    gap: 0.3rem;\r\n    padding: 0.3rem 1rem;\r\n    font-size: 0.75rem;\r\n    font-weight: 600;\r\n    letter-spacing: 0.15em;\r\n    color: #D5BE9B;\r\n    background: rgba(213, 190, 155, 0.15);\r\n    border: 1px solid rgba(213, 190, 155, 0.5);\r\n    border-radius: 20px;\r\n    text-shadow: 0 0 10px rgba(195, 136, 48, 0.5);\r\n    box-shadow: 0 0 15px rgba(195, 136, 48, 0.2);\r\n    animation: founderGlow 2s ease-in-out infinite alternate;\r\n    -webkit-text-fill-color: #D5BE9B;\r\n}\r\n\r\n@keyframes founderGlow {\r\n    from {\r\n        box-shadow: 0 0 10px rgba(195, 136, 48, 0.2);\r\n        border-color: rgba(195, 136, 48, 0.4);\r\n    }\r\n\r\n    to {\r\n        box-shadow: 0 0 20px rgba(195, 136, 48, 0.4);\r\n        border-color: rgba(195, 136, 48, 0.7);\r\n    }\r\n}\r\n\r\n.hero-email {\r\n    font-size: 1.1rem;\r\n    letter-spacing: 0.1em;\r\n    color: rgba(213, 190, 155, 0.8);\r\n    margin: 0;\r\n}\r\n\r\n.hero-balance-row {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    font-size: 0.85rem;\r\n    letter-spacing: 0.1em;\r\n    color: rgba(213, 190, 155, 0.9);\r\n}\r\n\r\n.balance-value {\r\n    font-size: 1rem;\r\n    color: rgba(213, 190, 155, 1);\r\n}\r\n\r\n.balance-progress {\r\n    width: 100%;\r\n    max-width: 400px;\r\n    height: 8px;\r\n    border-radius: 1000px;\r\n    background-color: rgba(213, 190, 155, 0.2);\r\n    overflow: hidden;\r\n    margin-top: 0.4rem;\r\n}\r\n\r\n.progress-fill {\r\n    height: 100%;\r\n    background: linear-gradient(90deg, rgba(213, 190, 155, 0.7), rgba(255, 255, 255, 0.9));\r\n    border-radius: inherit;\r\n}\r\n\r\n.hero-redeem {\r\n    display: flex;\r\n    gap: 1.25rem;\r\n    align-items: center;\r\n    margin-top: 1.5rem;\r\n    width: 100%;\r\n    flex-wrap: nowrap;\r\n}\r\n\r\n.redeem-input {\r\n    flex: 1 1 0;\r\n    min-width: 0;\r\n    max-width: 520px;\r\n    padding: 1.1rem 2.25rem;\r\n    border-radius: 1000px;\r\n    border: 1px solid rgba(249, 230, 173, 0.4);\r\n    background: linear-gradient(135deg, rgba(6, 6, 6, 0.85) 0%, rgba(12, 12, 12, 0.92) 100%);\r\n    box-shadow:\r\n        inset 0 0 25px rgba(0, 0, 0, 0.6),\r\n        0 10px 25px rgba(0, 0, 0, 0.45);\r\n    color: rgba(249, 230, 173, 0.95);\r\n    font-family: 'CormorantSC-Regular', 'Times New Roman', serif;\r\n    font-style: italic;\r\n    letter-spacing: 0.08em;\r\n    font-size: 1.05rem;\r\n    transition: border-color 0.3s ease, box-shadow 0.3s ease, color 0.3s ease;\r\n}\r\n\r\n.redeem-input::placeholder {\r\n    color: rgba(249, 230, 173, 0.7);\r\n}\r\n\r\n.redeem-input:focus {\r\n    outline: none;\r\n    border-color: rgba(255, 220, 150, 0.9);\r\n    box-shadow:\r\n        inset 0 0 25px rgba(0, 0, 0, 0.55),\r\n        0 15px 35px rgba(0, 0, 0, 0.6),\r\n        0 0 12px rgba(255, 223, 158, 0.35);\r\n    color: rgba(255, 244, 214, 0.95);\r\n}\r\n\r\n.redeem-input-error {\r\n    border: 1px solid rgba(255, 138, 138, 0.8);\r\n    color: rgba(255, 200, 200, 0.95);\r\n    background: linear-gradient(135deg, rgba(24, 5, 5, 0.9) 0%, rgba(42, 6, 6, 0.9) 100%);\r\n    box-shadow:\r\n        inset 0 0 25px rgba(0, 0, 0, 0.6),\r\n        0 10px 25px rgba(122, 20, 20, 0.25);\r\n}\r\n\r\n.redeem-input-error::placeholder {\r\n    color: rgba(255, 190, 190, 0.8);\r\n}\r\n\r\n.redeem-btn {\r\n    flex: 0 0 auto;\r\n    white-space: nowrap;\r\n    padding: 1rem 2.8rem;\r\n    border-radius: 1000px;\r\n    border: 1px solid rgba(249, 230, 173, 0.5);\r\n    background: linear-gradient(135deg, rgba(7, 7, 7, 0.92) 0%, rgba(25, 25, 25, 0.9) 100%);\r\n    color: rgba(249, 230, 173, 0.9);\r\n    font-family: 'CormorantSC-Regular', 'Times New Roman', serif;\r\n    letter-spacing: 0.15em;\r\n    cursor: pointer;\r\n    transition: all 0.3s ease;\r\n    font-size: 1rem;\r\n    text-transform: uppercase;\r\n    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.45);\r\n}\r\n\r\n.redeem-btn:hover {\r\n    background: linear-gradient(135deg, rgba(40, 40, 40, 0.95) 0%, rgba(20, 20, 20, 0.9) 100%);\r\n    transform: translateY(-2px);\r\n    border-color: rgba(255, 220, 150, 0.9);\r\n    color: rgba(255, 244, 214, 0.95);\r\n}\r\n\r\n.redeem-btn:disabled {\r\n    opacity: 0.6;\r\n    cursor: not-allowed;\r\n    transform: none;\r\n    box-shadow: none;\r\n}\r\n\r\n\r\n.widget-card {\r\n    background-color: rgba(0, 0, 0, 0.45);\r\n    backdrop-filter: blur(20px);\r\n    -webkit-backdrop-filter: blur(20px);\r\n    border-radius: 24px;\r\n    padding: 2rem;\r\n    border: none;\r\n    text-align: center;\r\n    cursor: pointer;\r\n    color: rgba(213, 190, 155, 1);\r\n    position: relative;\r\n    isolation: isolate;\r\n    transition: all 0.3s ease;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: center;\r\n    min-width: 200px;\r\n    flex: 0 0 auto;\r\n}\r\n\r\n.widget-card::before {\r\n    content: '';\r\n    position: absolute;\r\n    inset: 0;\r\n    border-radius: 24px;\r\n    padding: 1px;\r\n    background: radial-gradient(203.89% 137.16% at 36.99% -13.51%, #FFDC6C 0%, #FFFFFF 0%, #B19742 76.21%, #A8924B 82.96%);\r\n    -webkit-mask:\r\n        linear-gradient(#fff 0 0) content-box,\r\n        linear-gradient(#fff 0 0);\r\n    -webkit-mask-composite: xor;\r\n    mask:\r\n        linear-gradient(#fff 0 0) content-box,\r\n        linear-gradient(#fff 0 0);\r\n    mask-composite: exclude;\r\n    pointer-events: none;\r\n}\r\n\r\n.widget-card:hover {\r\n    transform: translateY(-4px);\r\n}\r\n\r\n.widget-icon {\r\n    width: 80px;\r\n    height: 80px;\r\n    border-radius: 50%;\r\n    border: 2px solid rgba(213, 190, 155, 0.6);\r\n    background-color: rgba(0, 0, 0, 0.7);\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    margin-bottom: 1rem;\r\n}\r\n\r\n.widget-icon img {\r\n    width: 40px;\r\n    height: 40px;\r\n    object-fit: contain;\r\n}\r\n\r\n.widget-title {\r\n    font-family: 'CormorantSC-Regular', 'Times New Roman', serif;\r\n    font-size: 1.1rem;\r\n    letter-spacing: 0.1em;\r\n    margin: 0;\r\n}\r\n\r\n.user-center-actions {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 0.75rem;\r\n    flex: 0 0 auto;\r\n    min-width: 180px;\r\n}\r\n\r\n.action-button {\r\n    background-color: rgba(0, 0, 0, 0.45);\r\n    backdrop-filter: blur(20px);\r\n    -webkit-backdrop-filter: blur(20px);\r\n    border-radius: 24px;\r\n    border: none;\r\n    cursor: pointer;\r\n    padding: 1rem 1.5rem;\r\n    transition: all 0.3s ease;\r\n    position: relative;\r\n    isolation: isolate;\r\n    text-align: center;\r\n    width: 100%;\r\n}\r\n\r\n.action-button::before {\r\n    content: '';\r\n    position: absolute;\r\n    inset: 0;\r\n    border-radius: 24px;\r\n    padding: 1px;\r\n    background: radial-gradient(203.89% 137.16% at 36.99% -13.51%, #FFDC6C 0%, #FFFFFF 0%, #B19742 76.21%, #A8924B 82.96%);\r\n    -webkit-mask:\r\n        linear-gradient(#fff 0 0) content-box,\r\n        linear-gradient(#fff 0 0);\r\n    -webkit-mask-composite: xor;\r\n    mask:\r\n        linear-gradient(#fff 0 0) content-box,\r\n        linear-gradient(#fff 0 0);\r\n    mask-composite: exclude;\r\n    pointer-events: none;\r\n}\r\n\r\n.action-button-label {\r\n    font-family: 'CormorantSC-Regular', 'Times New Roman', serif;\r\n    font-size: 0.95rem;\r\n    letter-spacing: 0.15em;\r\n    color: rgba(213, 190, 155, 1);\r\n    white-space: nowrap;\r\n}\r\n\r\n.action-button:hover {\r\n    transform: translateY(-2px);\r\n    background-color: rgba(0, 0, 0, 0.6);\r\n}\r\n\r\n@media (max-width: 900px) {\r\n    .user-center-main-row {\r\n        flex-direction: column;\r\n    }\r\n\r\n    .user-center-hero {\r\n        flex-direction: column;\r\n        gap: 1.5rem;\r\n    }\r\n\r\n    .hero-redeem {\r\n        width: 100%;\r\n        flex-direction: column;\r\n        align-items: stretch;\r\n    }\r\n\r\n    .redeem-input {\r\n        width: 100%;\r\n        min-width: unset;\r\n    }\r\n\r\n    .redeem-btn {\r\n        width: 100%;\r\n    }\r\n\r\n    .widget-card {\r\n        min-width: unset;\r\n    }\r\n\r\n    .user-center-actions {\r\n        flex-direction: row;\r\n        min-width: unset;\r\n    }\r\n}\r\n\r\n@media (max-width: 540px) {\r\n    .user-center-page {\r\n        padding: 1rem;\r\n        padding-top: 5rem;\r\n        /* More space for header icons */\r\n        align-items: flex-start;\r\n        /* Prevent clipping */\r\n    }\r\n\r\n    .user-center-header-icons {\r\n        top: 1rem;\r\n        right: 1rem;\r\n    }\r\n\r\n    .user-center-hero {\r\n        padding: 1.5rem;\r\n        gap: 1.5rem;\r\n    }\r\n\r\n    .hero-left {\r\n        flex-direction: column;\r\n        align-items: center;\r\n        width: 100%;\r\n    }\r\n\r\n    .hero-avatar {\r\n        width: 90px;\r\n        height: 90px;\r\n        font-size: 1.5rem;\r\n        margin-bottom: 0.5rem;\r\n    }\r\n\r\n    .hero-info {\r\n        width: 100%;\r\n        align-items: center;\r\n        text-align: center;\r\n    }\r\n\r\n    .hero-name {\r\n        font-size: 1.8rem;\r\n    }\r\n\r\n    .hero-email {\r\n        font-size: 0.95rem;\r\n    }\r\n\r\n    .hero-divider {\r\n        width: 80%;\r\n        /* Don't span full width if centered */\r\n    }\r\n\r\n    .hero-balance-row {\r\n        width: 100%;\r\n        max-width: 280px;\r\n        justify-content: space-between;\r\n    }\r\n\r\n    .balance-progress {\r\n        width: 100%;\r\n        max-width: 280px;\r\n    }\r\n\r\n    .hero-redeem {\r\n        margin-top: 1rem;\r\n        gap: 0.75rem;\r\n    }\r\n\r\n    .redeem-input {\r\n        padding: 0.9rem 1.5rem;\r\n        font-size: 0.95rem;\r\n    }\r\n\r\n    .redeem-btn {\r\n        padding: 0.9rem;\r\n        width: 100%;\r\n    }\r\n\r\n    /* Transform Widgets to Horizontal List Items for better space usage */\r\n    .widget-card {\r\n        flex-direction: row;\r\n        padding: 1rem 1.5rem;\r\n        gap: 1rem;\r\n        align-items: center;\r\n        justify-content: flex-start;\r\n        min-height: 80px;\r\n    }\r\n\r\n    .widget-icon {\r\n        width: 48px;\r\n        height: 48px;\r\n        margin-bottom: 0;\r\n        /* Override the default margin */\r\n        flex-shrink: 0;\r\n    }\r\n\r\n    .widget-icon img {\r\n        width: 24px;\r\n        height: 24px;\r\n    }\r\n\r\n    .widget-title {\r\n        font-size: 1rem;\r\n        text-align: left;\r\n    }\r\n\r\n    .user-center-actions {\r\n        margin-top: 0.5rem;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
